import { SolNavbar, SolNavbarItem } from '@sol/components';
import { SolIcon } from '@sol/icons';
import { PrototypeRouteId } from '../../models/prototype-route-id';

export const threatExplorerNavbar: SolNavbar = {
  menu: [
    SolNavbarItem.of(PrototypeRouteId.threat_explorer_lists, {
      displayName: 'Threat Explorer',
      icon: SolIcon.radar,
      showChildrenInNavbar: false,
      children: [
        SolNavbarItem.of(PrototypeRouteId.threat_explorer_list, {
          displayName: 'asm-prototype.threat-explorer.list.name',
          nameParams: ['listName'],
          showChildrenInNavbar: false,
          showChildrenAsTabs: true,
          children: [
            SolNavbarItem.of(PrototypeRouteId.threat_explorer_list_detail, {
              displayName: 'Overview',
            }),
            SolNavbarItem.of(PrototypeRouteId.threat_explorer_list_software, {
              displayName: 'Technologies',
              children: [
                SolNavbarItem.of(PrototypeRouteId.threat_explorer_software_detail, {
                  displayName: 'asm-prototype.threat-explorer.software.name',
                  nameParams: ['softwareName'],
                  showChildrenAsTabs: true,
                  children: [
                    SolNavbarItem.of(PrototypeRouteId.threat_explorer_software_overview, {
                      displayName: 'Overview',
                    }),
                    SolNavbarItem.of(PrototypeRouteId.threat_explorer_software_activity, {
                      displayName: 'Activity',
                    }),
                  ],
                }),
              ],
            }),
            SolNavbarItem.of(PrototypeRouteId.threat_explorer_list_vulnerabilities, {
              displayName: 'Vulnerabilities',
              children: [
                SolNavbarItem.of(PrototypeRouteId.threat_explorer_vulnerability_detail, {
                  displayName: 'asm-prototype.threat-explorer.vulnerability.name',
                  nameParams: ['cveId'],
                }),
              ],
            }),
            SolNavbarItem.of(PrototypeRouteId.threat_explorer_list_activity, {
              displayName: 'Activity',
            }),
            SolNavbarItem.of(PrototypeRouteId.threat_explorer_list_notifications, {
              displayName: 'Notifications',
            }),
          ],
        }),
      ],
    }),
  ],
  system: [],
  account: [
    SolNavbarItem.of(PrototypeRouteId.account_section1, {
      children: [
        SolNavbarItem.of(PrototypeRouteId.account_preferences, {
          displayName: 'Preferences',
        }),
      ],
    }),
    SolNavbarItem.of(PrototypeRouteId.account_section2, {
      children: [SolNavbarItem.of(PrototypeRouteId.account_logout, { displayName: 'Logout' })],
    }),
  ],
};
